
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-404");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/404/index.js
// module id = S+KH
// module chunks = 7